













































import Vue from 'vue'
import NewsList from './components/NewsList.vue';
import SearchInput from './components/SearchInput.vue';
import CategoryFilter from './components/CategoryFilter.vue';
import DateFilter from './components/DateFilter.vue';
import Pagination from './components/Pagination.vue';
import NumberOfHits from './components/NumberOfHits.vue';
import Sort from './components/Sort.vue';
import { clearFilters } from './store/actions';
import { ICategoryFilter, IExtraLink, ITranslations } from './store/state';
import { scroller } from './helpers';
import { EventBus } from './helpers/EventBus.vue'

// Interfaces for component typechecking!
interface AppData {
	mobile: boolean;
}

interface AppMethods {
	clearFilters(): void,
	toTop(): void
}

interface AppComputed {
	categoryFilter: ICategoryFilter
	showPagination: boolean
	disableClear: boolean,
	title: string, 
    description: string,
	translations: ITranslations
	extraLinks: IExtraLink[]
}

interface AppProps {
	windowWidth: number
}

interface AppMethods {
}

export default Vue.extend<AppData, AppMethods, AppComputed, AppProps>({
	name: 'app',
	data() {
		return {
			mobile: false
		}
	},
	created() {
		EventBus.$on('scrollToTop', () => this.toTop());
		this.mobile = window.innerWidth <= 1024;
	},
	components: {
		NewsList,
		SearchInput,
		CategoryFilter,
		DateFilter,
		Pagination,
		NumberOfHits,
		Sort
	},
	computed: {
		categoryFilter() {
			return this.$store.getters.categoryFilter
		},
		showPagination() {
			return this.$store.getters.pages > 1
		},
		disableClear() {
			return !this.$store.getters.hasFilters
		},
        title() {
			return this.$store.getters.title
		},
        description() {
			return this.$store.getters.description
		},
        translations() {
			return this.$store.getters.translations
		},
		extraLinks() {
			return this.$store.getters.extraLinks
		}
	},
	methods: {
		clearFilters() {
			this.$store.dispatch(clearFilters({skipSearch: false}))
		},
		toTop() {
			const anchor = (this.$refs.anchor as HTMLElement);
			scroller(anchor, 200, {onDone: () => {
				EventBus.$emit('focusFirst')
			}, easing: 'ease-in'})
		}
	}
})
